import React from 'react';
import PropTypes from 'prop-types';

const WorkingStep = ({ stepNumber, title, description, image}) => {
    return (
        <div className={'all-working'}>
            <div className="how_works_image">
                <img src={image} alt={title} />
            </div>
            <div className="how_works-text">
                <h4 className="fw-bold">{stepNumber}</h4>
                <h4 className="fw-bold" style={{ color: "#9D3B24" }}>{title}</h4>
                <p className='custom-justify'>{description}</p>
            </div>
        </div>
    );
};

WorkingStep.propTypes = {
    stepNumber: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.any.isRequired
};

export default WorkingStep;
